import Aside from "./";
import { connect } from "react-redux";
import { Selectors } from "@/store/masterProfile/selectors";
import { Selectors as UserSelectors } from "@/store/user/selectors";
import { Actions } from "@/store/masterProfile/slice";

const mSp = (state) => ({
  isOwner: Selectors.isOwner(state),
  articles: Selectors.getArticles(state),
  discounts: Selectors.getPublicDiscountsWithDescription(state),
  //associates: Selectors.getAssociates(state),
  isPremium: Selectors.isPremium(state),
  //clients: Selectors.getClients(state),
  achieves: Selectors.getAchieves(state),
  coords: Selectors.getCoords(state),
  weekSchedule: Selectors.getWeekSchedule(state),
  modelSearchService: Selectors.getModelSearchService(state),
  masterId: Selectors.getMasterId(state),
  locale: UserSelectors.getLocale(state),
});
const mDp = {
  openFreeSlots: Actions.openFreeSlots,
};

export default connect(mSp, mDp)(Aside);
